import { storage } from './storageService';

const KEY = 'lastLoginProfile';

export interface RememberedLoginProfile {
  name: string;
  email: string;
  /** URL da foto (campo `cover` do usuário) */
  avatar?: string;
}

export function saveRememberedLoginProfile(user: {
  name: string;
  email: string;
  cover?: string;
}): void {
  storage.set(KEY, {
    name: user.name,
    email: user.email.trim().toLowerCase(),
    avatar: user.cover,
  } satisfies RememberedLoginProfile);
}

export function getRememberedLoginProfile(): RememberedLoginProfile | null {
  const raw = storage.get<RememberedLoginProfile>(KEY);
  if (!raw?.email?.trim()) return null;
  return raw;
}

export function clearRememberedLoginProfile(): void {
  storage.remove(KEY);
}
